"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = void 0;
var ramda_1 = require("ramda");
/**
 *  Проверяет является ли переданный аругмент объектом - {}
 */
function isObject(val) {
    return !(0, ramda_1.isNil)(val) && typeof val === 'object' && !Array.isArray(val);
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map